export const SettingsActionTypes = {
  GetCustomers: 'GET_CUSTOMERS',
  GetCustomersSuccess: 'GET_CUSTOMERS_SUCCESS',
  GetCustomersError: 'GET_CUSTOMERS_ERROR',
  GetTemplatesByCustomerId: 'GET_TEMPLATES_BY_CUSTOMER_ID',
  GetTemplatesByCustomerIdSuccess: 'GET_TEMPLATES_BY_CUSTOMER_ID_SUCCESS',
  GetTemplatesByCustomerIdError: 'GET_TEMPLATES_BY_CUSTOMER_ID_ERROR',
  GetActiveProjects: 'GET_ACTIVE_PROJECTS',
  GetActiveProjectsSuccess: 'GET_ACTIVE_PROJECTS_SUCCESS',
  GetActiveProjectsError: 'GET_ACTIVE_PROJECTS_ERROR',
  ClearSettings: 'CLEAR_SETTINGS',
  ClearActiveProjects: 'CLEAR_ACTIVE_PROJECTS',
  GetKenticoProjects: 'GET_KENTICO_PROJECT',
  GetKenticoProjectsSuccess: 'GET_KENTICO_PROJECT_SUCCESS',
  GetKenticoProjectsError: 'GET_KENTICO_PROJECT_ERROR',
  GetAvailableLanguages: 'GET_AVAILABLE_LANGUAGES',
  GetAvailableLanguagesSuccess: 'GET_AVAILABLE_LANGUAGES_SUCCESS',
  GetAvailableLanguagesError: 'GET_AVAILABLE_LANGUAGES_ERROR',
};
